// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"bc230543","lsc":"842a2f8d","others":"0daed5a2"}[chunkId] + ".chunk.js";
};